import React, { MouseEventHandler } from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

type Prop = {
  type?: 'button' | 'dropdown';
  icon?: string;
  dropDownList?: { url: string; lable: string }[];
  lable?: string;
  createNewFormLabel?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
  onCreateNewForm?: MouseEventHandler<HTMLElement>;
  variant?: 'danger' | 'primary' | 'success';
  onClickMenu?: (event: MouseEvent) => void;
  isShowDropDownList?: boolean;
  hideAddNewButton?: boolean;
  hideEditButton?: boolean;
  disableAddNewButton?: boolean;
};

const SubmitBtn = styled(Button)`
  && {
    margin-left: 8px;
    background-color: ${(props) => props.theme.colors.lightSeaGreen};
    border-radius: 8px;
    border: none;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: ${(props) => props.theme.colors.white};
    height: 40px;

    :hover:not([disabled]),
    :active,
    :focus {
      background-color: ${(props) => props.theme.colors.lightSeaGreen} !important;
    }

    :disabled {
      cursor: initial;
    }
  }
`;

const handleButtonColor = (
  type: 'danger' | 'success' | 'primary' = 'primary',
  theme: any,
): string => {
  if (type === 'danger') return theme.radicalRed;
  if (type === 'primary') return theme.malibu;
  return theme.malibu;
};
type EditButtonProps = {
  variant?: 'danger' | 'primary' | 'success';
};
const EditButton = styled(Button)<EditButtonProps>`
  && {
    margin-left: 8px;
    background-color: ${(props) => handleButtonColor(props?.variant, props.theme.colors)};
    border-radius: 8px;
    border: none;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: ${(props) => props.theme.colors.white};
    height: 40px;

    :disabled {
      color: #ffffff;
      background-color: #5cabdc;
      border-color: #212121;
    }

    :hover,
    :active,
    :focus {
      opacity: 1;
      background-color: ${(props) =>
        props.disabled
          ? props.theme.colors.malibu
          : handleButtonColor(props?.variant, props.theme.colors)} !important;
    }
    &:disabled {
      opacity: 1;
      background-color: #757677 !important;
    }
    &:disabled:hover {
      background-color: #757677 !important;
      cursor: default !important;
    }
  }
`;

const WrapedDropdown = ({ ...props }) => {
  return <Dropdown {...props} as={ButtonGroup} />;
};

const DropdownBox = styled(WrapedDropdown)`
  && button {
    background-color: ${(props) => props.theme.colors.malibu};
    border-radius: 8px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: ${(props) => props.theme.colors.white};
    height: 40px;

    :hover,
    :active,
    :focus,
    :not(.btn-text),
    ::after {
      background-color: ${(props) => props.theme.colors.malibu} !important;
    }

    &.btn.dropdown-toggle-split {
      opacity: 1;
    }
  }
`;

const DropDownMenu = styled(Dropdown.Menu)`
  box-shadow: 0px 4px 8px ${(props) => props.theme.colors.black012};
  border-radius: 8px;
  width: 100%;
  margin-top: 4px;
`;

const DropDownItem = styled(Dropdown.Item)`
  :active,
  :hover {
    background-color: ${(props) => props.theme.colors.malibu01};
  }
`;

const Wrapper = styled.div`
  display: flex;

  @media (max-width: 700px) {
    gap: 8px;
    > button {
      margin-left: 0px !important;
    }
  }
`;

const ButtonSubmit: React.VFC<Prop> = ({
  type,
  icon,
  dropDownList,
  lable,
  createNewFormLabel,
  onClick,
  onCreateNewForm,
  disabled,
  variant,
  onClickMenu,
  isShowDropDownList = true,
  hideAddNewButton = false,
  hideEditButton = false,
  disableAddNewButton = false,
}) => {
  const checkType = () => {
    switch (type) {
      case 'button':
        return (
          <>
            {onCreateNewForm && !hideAddNewButton && (
              <EditButton type="button" onClick={onCreateNewForm} disabled={disableAddNewButton}>
                {createNewFormLabel}
              </EditButton>
            )}
            {!hideEditButton && (
              <EditButton type="button" variant={variant} onClick={onClick} disabled={disabled}>
                {lable}
              </EditButton>
            )}
          </>
        );
      case 'dropdown':
        return (
          <DropdownBox>
            <Button disabled={disabled} onClick={onClick}>
              {lable}
            </Button>
            {isShowDropDownList && (
              <>
                <Dropdown.Toggle split />
                <DropDownMenu>
                  {dropDownList
                    ? dropDownList.map((item, index) => (
                        <DropDownItem
                          key={`dropdown-submit-${index}`}
                          href={item.url}
                          name={item.lable}
                          value={item.lable}
                          onClick={(event: MouseEvent) => {
                            if (event) {
                              onClickMenu && onClickMenu(event);
                            }
                          }}
                        >
                          {item.lable}
                        </DropDownItem>
                      ))
                    : undefined}
                </DropDownMenu>
              </>
            )}
          </DropdownBox>
        );
      default:
        return (
          <SubmitBtn disabled={disabled} type="submit" onClick={onClick}>
            {lable}
          </SubmitBtn>
        );
    }
  };

  return <Wrapper className="d-flex">{checkType()}</Wrapper>;
};
export default ButtonSubmit;
